import { type PlanMutationPayload } from '@/features/shop/services/DeliveryPlans/types'
import {
  type MembershipInterval,
  type MembershipPlanType,
  type MembershipStatus,
  type SubscriptionPlanResponse,
} from '@/features/account/services/MembershipPlan/types'

type Notice = {
  copy: string
  style?: 'strong'
  link_url?: string
}

export type AutoRenewal = {
  notice: Notice[]
  check_box: Notice[]
  notes: Notice[][]
}

export enum SubscriptionPlanType {
  STUDENT = 'student',
  EBT = 'ebt',
  STANDARD = 'standard',
  UPGRADE = 'upgrade',
  DOWNGRADE = 'downgrade',
  EARLY_RENEWAL = 'early_renewal',
}

export type AuxMembershipPlan = {
  id: PlanMutationPayload['package_id']
  total_cost_cents: number
  total_base_cents: number
  trial_period_days: number
  plan_type: SubscriptionPlanType
  interval: PlanInterval
  single_delivery_fee_cents: number
  display?: {
    name: string
    name_with_article: string
    billing_frequency: string
    billing_interval: string
    price_dollars: string
    original_price_dollars: string
    is_discounted: boolean
    discount_amount_dollars: string
    includes_refund: boolean
    promo_expires_at?: string
    tracking_name?: string
    next_full_charge_at?: string
    auto_renewal?: AutoRenewal
    price_text?: string
    price_period_text?: string
    promo_iterations?: number
  }
}

export type AuxPurchasePlan = {
  id?: string
  status?: MembershipStatus
  type?: MembershipPlanType
  start?: number
  canceled_at?: number
  cancel_at_period_end?: boolean
  current_period_start?: number
  current_period_end?: number
  plan: SubscriptionPlanResponse
  discount?: {
    applies_at?: number | null
    coupon_id?: string | null
    created_at?: number | null
    next_full_charge_at?: number | null
    next_full_charge_amount?: number | null
    next_full_charge_interval?: MembershipInterval | null
    percent_off?: number | null
  }
  trial_end?: number
  trial_start?: number
  refundable?: boolean
}

export enum PlanInterval {
  MONTHLY = 'monthly',
  ANNUAL = 'annual',
}
